import React, {Component} from 'react';
import _ from 'lodash';

class PopComponents extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            attach: false,
            boton: false,
            elastico: false,
            potenciador: false
        };
        this.postitions = {
            18: {
                top: 0,
                left: 4,
                arrow: "right"
            },
            17: {
                top: 0,
                left: 11,
                arrow: "right"
            },
            16: {
                top: 0,
                left: 18,
                arrow: "right"
            },
            15: {
                top: 0,
                left: 24,
                arrow: "right"
            },
            14: {
                top: 0,
                left: 29,
                arrow: "right"
            },
            13: {
                top: 0,
                left: 35,
                arrow: "right"
            },
            12: {
                top: 0,
                left: 41,
                arrow: "right"
            },
            11: {
                top: 0,
                left: 46,
                arrow: "right"
            },
            21: {
                top: 0,
                right: 47,
                arrow: "left"
            },
            22: {
                top: 0,
                right: 41,
                arrow: "left"
            },
            23: {
                top: 0,
                right: 35,
                arrow: "left"
            },
            24: {
                top: 0,
                right: 30,
                arrow: "left"
            },
            25: {
                top: 0,
                right: 24,
                arrow: "left"
            },
            26: {
                top: 0,
                right: 18,
                arrow: "left"
            },
            27: {
                top: 0,
                right: 10,
                arrow: "left"
            },
            28: {
                top: 0,
                right: 4,
                arrow: "left"
            },
            48: {
                bottom: -27,
                left: 4,
                arrow: "right"
            },
            47: {
                bottom: -27,
                left: 13,
                arrow: "right"
            },
            46: {
                bottom: -27,
                left: 22,
                arrow: "right"
            },
            45: {
                bottom: -27,
                left: 28,
                arrow: "right"
            },
            44: {
                bottom: -27,
                left: 33,
                arrow: "right"
            },
            43: {
                bottom: -27,
                left: 39,
                arrow: "right"
            },
            42: {
                bottom: -27,
                left: 44,
                arrow: "right"
            },
            41: {
                bottom: -27,
                left: 47,
                arrow: "right"
            },
            31: {
                bottom: -27,
                right: 47,
                arrow: "left"
            },
            32: {
                bottom: -27,
                right: 44,
                arrow: "left"
            },
            33: {
                bottom: -27,
                right: 39,
                arrow: "left"
            },
            34: {
                bottom: -27,
                right: 34,
                arrow: "left"
            },
            35: {
                bottom: -27,
                right: 28,
                arrow: "left"
            },
            36: {
                bottom: -27,
                right: 21,
                arrow: "left"
            },
            37: {
                bottom: -27,
                right: 13,
                arrow: "left"
            },
            38: {
                bottom: -27,
                right: 5,
                arrow: "left"
            },
        }
    }
    componentDidMount(){
        ["attach", "boton", "elastico", "potenciador"].forEach(item => {
            this.setState({[item]: _.filter(this.props.components, {field: item}).length });
        });
    }
    toggleCheckbox(e) {
        const newState = this.state;
        newState[e.target.name] = this.state[e.target.name] === 0 ? 1 : 0;
        this.setState(newState);
    }
    applyChanges(){
        this.props.addComponent(this.state);
        this.props.close();
    }

    render() {
        const position = {
            position: "absolute",
            width: "190px",
            top: !this.postitions[this.props.selected].top ? 'auto' : `${this.postitions[this.props.selected].top}px`,
            bottom: !this.postitions[this.props.selected].bottom ? 'auto' : `${this.postitions[this.props.selected].bottom}px`,
            left: !this.postitions[this.props.selected].left ? 'auto' : `${this.postitions[this.props.selected].left}%`,
            right: !this.postitions[this.props.selected].right ? 'auto' : `${this.postitions[this.props.selected].right}%`
        };
        const classes = `popover fade bs-popover-${this.postitions[this.props.selected].arrow} show`;
        return (
            <div className={classes} role="tooltip"
                 style={position}
            >
                <div className="arrow" style={{top: "68px"}}></div>
                <div className="popover-body">
                    <ul className="list-unstyled">
                        <li>
                            <label htmlFor="attach">
                                <input checked={this.state.attach}
                                       onChange={this.toggleCheckbox.bind(this)}
                                       type="checkbox"
                                       id="attach"
                                       name="attach"/> Atache
                            </label>
                        </li>
                        <li>
                            <label htmlFor="boton">
                                <input checked={this.state.boton}
                                       onChange={this.toggleCheckbox.bind(this)}
                                       type="checkbox"
                                       id="boton"
                                       name="boton"/> Botón
                            </label>
                        </li>
                        <li>
                            <label htmlFor="elastico">
                                <input checked={this.state.elastico}
                                       onChange={this.toggleCheckbox.bind(this)}
                                       type="checkbox"
                                       id="elastico"
                                       name="elastico"/> Elástico
                            </label>
                        </li>
                        <li>
                            <label htmlFor="potenciador">
                                <input checked={this.state.potenciador}
                                       onChange={this.toggleCheckbox.bind(this)}
                                       type="checkbox"
                                       id="potenciador"
                                       name="potenciador"/> Potenciador de torque
                            </label>
                        </li>
                    </ul>
                    <button className="btn btn-primary" onClick={this.applyChanges.bind(this)} type="button">Aplicar</button>
                    <button className="btn btn-link" onClick={this.props.close} type="button">Cancelar</button>
                </div>
            </div>
        );
    }
}

class Odontograma extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: [],
            popover: false,
            activePiece: null,
            posx: null
        };
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.pieces && nextProps.pieces.value) {
            let values = nextProps.pieces.value[0] && nextProps.pieces.value[0].caso_id ? _.map(nextProps.pieces.value, 'value') : nextProps.pieces.value;
            this.setState({selected: nextProps.pieces.value})
        } else {
            this.setState({selected: []})
        }
    }

    closePopover() {
        this.setState({popover: false});
    }

    clickPiece(e) {
        if (!this.props.isEditable) {
            return false
        }
        let idSelected = e.target.id;
        let posx = e.target.getBoundingClientRect().x;
        this.setState({activePiece: idSelected, popover: true, posx});
        /*
        let newSelected = this.state.selected;
        this.props.selectPiece(this.props.id, this.props.type, newSelected, e.target.id)

        if(_.includes(newSelected, idSelected)){
            newSelected = _.pickBy(newSelected, function(value, key) {return value !== idSelected;})
        } else {
            newSelected = _.toArray(newSelected);
            newSelected.push(idSelected)
        }
        this.setState({selected: newSelected});
        */
    }
    addComponent(pieceState){
        const newSelected = this.state.selected.filter(item => { return item.value !== this.state.activePiece });
        const actSelected = [];
        let pieceAct;
        ["attach", "boton", "elastico", "potenciador"].forEach(item => {
            if(pieceState[item]){
                pieceAct = {
                    step: this.props.id,
                    type: 1,
                    field: item,
                    value: this.state.activePiece
                }
                newSelected.push(pieceAct);
                actSelected.push(pieceAct);
            }
        });
        this.setState({selected: newSelected});
        this.props.selectPiece(this.props.id, this.props.type, newSelected, actSelected, this.state.activePiece);
    }
    renderComponent(piece, posx, posy, type){
        if(_.filter(this.state.selected, item => {return item.value === piece && item.field === "attach"}).length !== 0 && type === "attach") {
            return (
                <g transform={`translate(${posx},${posy})`}>
                    <rect y="4.79" width="10.78" height="1.81" fill="#bad636"></rect>
                    <polygon points="5.39 0 10.78 3.9 0 3.9 5.39 0" fill="#bad636"></polygon>
                </g>
            );
        } else if(_.filter(this.state.selected, item => {return item.value === piece && item.field === "elastico"}).length !== 0 && type === "elastico"){
            return(
                <g transform={`translate(${posx},${posy})`}>
                    <polygon points="13.95 3.85 10.1 0 6.97 3.13 3.85 0 0 3.85 3.13 6.97 0 10.1 3.85 13.95 6.97 10.82 10.1 13.95 13.95 10.1 10.82 6.97 13.95 3.85" fill="#bad636" />
                </g>
            );
        } else if(_.filter(this.state.selected, item => {return item.value === piece && item.field === "potenciador"}).length !== 0 && type === "potenciador"){
            return(
                <g transform={`translate(${posx},${posy})`}>
                    <rect width="14.29" height="5.1"  fill="#bad636" />
                </g>
            );
        } else if(_.filter(this.state.selected, item => {return item.value === piece && item.field === "boton"}).length !== 0 && type === "boton"){
            return(
                <g transform={`translate(${posx},${posy})`}>
                    <path d="M7.14,0a7.14,7.14,0,1,0,7.14,7.14A7.14,7.14,0,0,0,7.14,0Zm0,11.31a4.17,4.17,0,1,1,4.17-4.17A4.17,4.17,0,0,1,7.14,11.31Z" fill="#bad636"/>
                </g>
            );
        }else{
            return null;
        }
    }
    render() {
        return (
            <div className={"od-container " + this.props.type + "_" + this.props.id}>
                {this.state.popover &&
                    <PopComponents
                        close={this.closePopover.bind(this)}
                        selected={this.state.activePiece}
                        components={_.filter(this.state.selected, {value: this.state.activePiece})}
                        posx={this.state.posx}
                        addComponent={this.addComponent.bind(this)}
                    />
                }
                <svg viewBox="-30 -45 415 175">
                    <path id="superior" data-name="superior" className="od-linea"
                          d="M590.13,306.94s2.52-4.56,6.88-6.3,6.37-.87,8.22.91,3.11,1.87,4.72,1.34,4.12-4.26,6.35-3.87,5.56,1.77,6.49,4.16a16.87,16.87,0,0,1-.9,15.35s-.31,1.6-6.59,1.35-4.87-.85-10.33-.18-7,1.48-9.92.18-4.83-9.46-4.83-9.46a16.05,16.05,0,0,1-2.33,8s-.31,1.6-6.59,1.35-4.87-.85-10.33-.18-7,1.48-9.92.18-4.46-8.74-4.46-8.74a33.44,33.44,0,0,1-1.63,5.42c-1.24,3.26-1.06,4.8-6.87,5.47s-8.14,2.44-13,1.94-10.14-3-10.66-5.63-2.24-7.58-2.24-7.58a13.3,13.3,0,0,0-1.84,5.14c-.4,3,0,5.8-2.84,6.66s-11.76,1.4-13.19-.44-2.54-6.33-2.81-7.24-2.28-5.21-2.28-5.21-1.32,3.61-2.28,6.66-1.45,7.31-8.29,7.12-8-1.68-10.27-7.51-2.55-5.63-2.55-5.63,0,4.75-.23,9.21-.67,10.39-7.58,10.27-8.13-2.59-9.65-7.22-4.1-13.13-4.1-13.13-1.24-1.21-1.54,8S449,329.59,446,329.54s-4.88-.71-6.71-7.94-2.71-8.85-2.71-8.85-.65,5.3-.9,7.6-.33,7-4.8,7.18-6.2-.88-8-9.64-2.13-9.81-2.13-9.81-1.13.4-1.71,5.84-1.72,14.64-7.37,14.12-6.81-1.73-7-13.6c0,0-.69-.71-1.76,4.93s-1.79,10.44-7.44,10.14-6.17-6.81-6.92-11.43a78.21,78.21,0,0,0-1.75-8.06s-.71.83-2.8,8.61S378.9,330,373.54,329.39s-7-1.8-7.58-9.84-.84-8-.84-8-2.25,12.74-12.08,11.73-7.46-4.46-10.67-13c0,0-.84-.08-1.6,3.32s-1.36,10-9.45,9.26-7.43,1.34-9.82-5.62-1.93-5.2-1.93-5.2-.5.48-2.17,4.36-6.83,7.14-10.94,6.72-5.49-1.63-9.75-1.78-5.74,1-7.46-.9S285.6,310,285.6,310a8.88,8.88,0,0,0-1.88,3.95c-.53,2.5.24,6.29-6,6.18s-9.63-.66-14.3-.67-8.33,1.18-10.14-3.18a21.76,21.76,0,0,1-1.52-6.3l-.11.15a8.88,8.88,0,0,0-1.88,3.95c-.53,2.5.24,6.29-6,6.18s-9.63-.66-14.3-.67-8.33,1.18-10.14-3.18-2.87-11.85,1.32-15.55,7.57-1.4,9.91.31,3.95,1.88,5.44.44,3.61-2.94,6-2.41,8,1.38,9.83,7.21a9,9,0,0,1,2.77-5.69c4.18-3.7,7.57-1.4,9.91.31s3.95,1.88,5.44.44,3.61-2.94,6-2.41,7.93,2,9.78,7.78c0,0,1.76-5.07,6-6.11s5.4-1,9.15-.33,2.15,1,5,0,6.67-2.26,9.86-.81,3.65,7,3.65,7,2.48-2.33,5.18-4.8a10.55,10.55,0,0,1,8-2.86c2.3.18,7.23,2,9.71,8a17.9,17.9,0,0,1,6.83-7.07c4.44-2.3,10.45-2.54,16.7,7.28,0,0-.27-4.4,4.79-6.55s8.23-3.35,11.19-1,5,3.65,5.08,4.77,2.22-3.38,3.77-3.91,4-.21,7.48-.22,6.5-.09,6.73,2.7c0,0,.11-2.16,4-2.44s11.12-.92,12,2.24c0,0-.3-2.73,5-2.57s10.61.18,10.84,3.19c0,0,.19-3,4-3.07s8.18-.28,10.11.74,3.22,3.55,3.68,5.3a10.32,10.32,0,0,1,4.08-5.59c3.18-2,4.86-2.5,7.91-1.26s8.68,2.81,9.79,7c0,0,.6-2.43,4.77-5s3.7-3.71,6.41-3.1,5.22,1.28,7.48,3.48a43.64,43.64,0,0,1,4.58,5.6s2.27-5.76,6.7-7.7,10.53.81,15.46,6.69a9.69,9.69,0,0,1,2.38-4.43c1.77-1.65,2-3.18,4.85-2s6.95,2.08,9,1.69,6.47-2.33,11-.44,6.1,2.62,7.24,5.43c0,0,2.52-4.56,6.88-6.3s6.37-.87,8.22.91,3.11,1.87,4.72,1.34,4.12-4.26,6.35-3.87,5.56,1.77,6.49,4.16A13.71,13.71,0,0,1,590.13,306.94Z"
                          transform="translate(-243.42 -248.22)"></path>
                    <path id="inferior" data-name="inferior" className="od-linea"
                          d="M601,264.12c.25-2.09.73-5.64,3.52-5.87s7,1.52,10.18,1.09,8.83-1.94,9.78-.25a28.24,28.24,0,0,1,2.35,9.61c.15,3.28.71,7.14-4.84,9.27s-8,.77-9.33-1.84c0,0-.24,1.67-3.18,2.39s-5.69,1.86-7.74-.48a35.09,35.09,0,0,1-2.33-2.95.93.93,0,0,0-1.5,0,11.93,11.93,0,0,1-4.92,3.12c-5.55,2.14-8,.77-9.33-1.84,0,0-.24,1.67-3.18,2.39s-5.69,1.86-7.74-.48-3.56-4.18-3.56-4.18a4.41,4.41,0,0,0-2.26,1.43c-.58,1-2.44,4-4.89,4.24s-7.26,0-8.61-2.94a33.2,33.2,0,0,0-4.08,1.67c-3.1,1.41-8.69,1.66-11.44-4.88,0,0-1.42,1.51-3.77,4.05s-3.65,5.24-7.82,3.78-7.93-6-8.81-7.28a7.14,7.14,0,0,0-1.51-1.7s.25,1.89-2,4.29-7.43,5.39-9.79,4.93a12.54,12.54,0,0,1-6.22-3.46,46.75,46.75,0,0,1-4.36-6s-.82-.85-2.19,1.36-5.68,9.26-12,8.59-11.16-8.92-11.16-8.92a24.8,24.8,0,0,1-1.83,4.79c-.86,1.31-1.92,1.85-6.11,1.78s-11.48,1.41-13.64-2.75c0,0-.21,4-7.75,3.85s-17.49,1.65-18.58-3.54c0,0,.92,3.16-8.72,3.41s-14.77,2.26-17.17-4.49c0,0,.43,3.43-8.37,3.28s-10.1,2.27-13.3-6a26.75,26.75,0,0,1-5.7,6.6c-3.19,2.39-11.59,3.85-18.63-8.84,0,0-1,6.13-6,8.35s-12.43,4.11-17.2-7a17,17,0,0,1-5.56,6.26c-4,2.72-8.38,3.83-11,.37a35.58,35.58,0,0,0-5.42-5.75,21,21,0,0,0-2.85,3c-1.92,2.27-3.34,3.64-6.39,2.33s-5.54-2.54-5.54-2.54.13.63-2.55,1.91-5.36,2.91-8.23-.28a23.29,23.29,0,0,0-5-4.42s-1.12,0-2.06,1.92-2,4.57-6.07,3.73a12.19,12.19,0,0,1-6.56-4.23,3.09,3.09,0,0,1-1.23,2.7,5.17,5.17,0,0,1-5.47,1.23,20.84,20.84,0,0,1-6-3,12.81,12.81,0,0,1-1.93-1.77.56.56,0,0,0-.94.09c-.14.26-.31.6-.53,1-.94,1.94-2,4.57-6.07,3.73a12.19,12.19,0,0,1-6.56-4.23,3.09,3.09,0,0,1-1.23,2.7,5.17,5.17,0,0,1-5.47,1.23c-2.15-.81-5.21-1.56-6-3s-2.31-7.44-.4-13.07,3.59-5.38,7.62-4.62,4.39.7,7.12-.08,8.38-.27,8.92,1a35.1,35.1,0,0,1,2.25,7.23c.64,3.36.9,2.93.9,2.93.76-2,1.21-4.11,1.93-6.22,1.91-5.62,3.59-5.38,7.62-4.62s4.39.7,7.12-.08,8.38-.27,8.92,1a35.1,35.1,0,0,1,2.25,7.23c.64,3.36,1.61,3.66,1.61,3.66a11.76,11.76,0,0,0,1.6-3.67c.31-1.74.62-7.74,3.08-8.26a36.65,36.65,0,0,1,9-.89c5-.05,6.71-.44,10.14-.59s3.83.69,4.82,3.79,2.8,7.87,2.8,7.87a13.35,13.35,0,0,0,1.82-4.51c.54-2.64.21-4,1.21-5.36s3.47-2.52,6.54-2.4,6.92-.58,8.18,3.22a63.86,63.86,0,0,0,4.17,8.94s1.8-3.32,1.84-5.14.74-6.41,3.75-6.92,6-.87,7.9-.49,4.93,1.34,5.66,3.87,2.92,8.43,3.42,8.09,0-7.47,1.29-10a10.06,10.06,0,0,1,8.54-5.3c4.05-.07,7.8,1.32,9.14,4.42s2.93,8.43,3.6,9.63,1.62,3.17,2,2.76a8.15,8.15,0,0,0,.85-4.45c-.26-1.33-.92-11.12,6.15-12.32s11.74,7.82,13.82,16.23a33.69,33.69,0,0,0,1.81-7.44c.42-3.83.56-8.3,3.25-10.14s8.85-2.71,11.06-1.34,5.35,1.49,7.32,8.72,3.54,13.4,3.54,13.4.9-3.75,2.54-9.45,4.34-12.77,11.89-13.13,10.31,5.56,10.88,8.85,1.34,11.06,1.34,11.06,2.69-5.89,4.22-9.56,6.14-7.64,10.52-6.73,5.69,5.9,6,11.42.31,6,.31,6a24.63,24.63,0,0,0,3.17-5.53c.81-2.43,3-8.61,5.76-10.24s8.62-1.46,11-.5,4.67,4.69,4.74,8.6,0,6.29,0,6.29a47.44,47.44,0,0,0,3.12-6.65c.88-2.71,2.63-6.52,9.18-6.06s9.61,1.43,10.2,11.77a28.34,28.34,0,0,0,3.31-5.53c1-2.57,1.83-5.07,4.77-5.5s10.2-.31,11,2.08,3,9.2,3,9.2a46.63,46.63,0,0,0,3-7.7c.54-2.64,2.3-3.66,7.18-3.3s6.54,1.3,11.5,1.25,6.42,0,7.41,3.34,2.49,9.12,2.49,9.12,2.38-4.22,2.62-6.31.73-5.64,3.52-5.87,7,1.52,10.18,1.09,8.83-1.94,9.78-.25,2.16,7.59,3.35,9.61C598.95,269.15,600.74,266.21,601,264.12Z"
                          transform="translate(-243.42 -248.22)"></path>
                    <text y="5" x="7">17</text>
                    {this.renderComponent("17", 9, 15, "attach")}
                    {this.renderComponent("17", 7, -17, "elastico")}
                    {this.renderComponent("17", 7, 35, "potenciador")}
                    {this.renderComponent("17", 7, -35, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M267.06,266.91c0,4-6.28,7.32-10.32,7.32s-10.32-3.28-10.32-7.32,6.28-7.32,10.32-7.32S267.06,262.87,267.06,266.91Z"
                          transform="translate(-243.42 -248.22)" id="17"></path>
                    <text y="5" x="-21">18</text>
                    {this.renderComponent("18", -22, -17, "elastico")}
                    {this.renderComponent("18", -19, 15, "attach")}
                    {this.renderComponent("18", -20, 35, "potenciador")}
                    {this.renderComponent("18", -22, -35, "boton")}
                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M267.06,266.91c0,4-6.28,7.32-10.32,7.32s-10.32-3.28-10.32-7.32,6.28-7.32,10.32-7.32S267.06,262.87,267.06,266.91Z"
                          transform="translate(-271 -248.22)" id="18"></path>
                    <text y="5" x="37">16</text>
                    {this.renderComponent("16", 39, 15, "attach")}
                    {this.renderComponent("16", 38, -17, "elastico")}
                    {this.renderComponent("16", 38, 35, "potenciador")}
                    {this.renderComponent("16", 38, -35, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M299.6,266.91c0,4.65-6.77,8.42-11.42,8.42s-11.42-3.77-11.42-8.42,6.77-8.42,11.42-8.42S299.6,262.26,299.6,266.91Z"
                          transform="translate(-243.42 -248.22)" id="16"></path>
                    <text y="2" x="65">15</text>
                    {this.renderComponent("15", 65, 15, "attach")}
                    {this.renderComponent("15", 66, -17, "elastico")}
                    {this.renderComponent("15", 66, 35, "potenciador")}
                    {this.renderComponent("15", 66, -35, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M321.49,266.91c0,4-3.28,11.32-7.32,11.32s-7.32-7.28-7.32-11.32,3.28-9.32,7.32-9.32S321.49,262.87,321.49,266.91Z"
                          transform="translate(-243.42 -248.22)" id="15"></path>
                    <text y="2" x="87">14</text>
                    {this.renderComponent("14", 87, 15, "attach")}
                    {this.renderComponent("14", 88, -17, "elastico")}
                    {this.renderComponent("14", 88, 35, "potenciador")}
                    {this.renderComponent("14", 88, -35, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M329.66,268c0-4,3.26-10.29,7.29-10.29s7.29,6.26,7.29,10.29-3.26,10.29-7.29,10.29S329.66,272.07,329.66,268Z"
                          transform="translate(-243.42 -248.22)" id="14"></path>
                    <text y="0" x="107">13</text>
                    {this.renderComponent("13", 110, 15, "attach")}
                    {this.renderComponent("13", 111, -17, "elastico")}
                    {this.renderComponent("13", 111, 35, "potenciador")}
                    {this.renderComponent("13", 111, -35, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M352.41,268c0-4,3.26-12.29,7.29-12.29S367,264,367,268s-2.26,11.29-6.29,11.29S352.41,272.07,352.41,268Z"
                          transform="translate(-243.42 -248.22)" id="13"></path>
                    <text y="0" x="130">12</text>
                    {this.renderComponent("12", 134, 15, "attach")}
                    {this.renderComponent("12", 135, -17, "elastico")}
                    {this.renderComponent("12", 135, 35, "potenciador")}
                    {this.renderComponent("12", 135, -35, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M391.07,266.91c0,4-3.28,10.76-7.32,10.76s-7.32-6.72-7.32-10.76,3.28-11.32,7.32-11.32S391.07,262.87,391.07,266.91Z"
                          transform="translate(-243.42 -248.22)" id="12"></path>
                    <text y="-2" x="157">11</text>
                    {this.renderComponent("11", 157, 15, "attach")}
                    {this.renderComponent("11", 158, -22, "elastico")}
                    {this.renderComponent("11", 158, 35, "potenciador")}
                    {this.renderComponent("11", 158, -40, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M416.15,266.91c0,5.14-4.17,12.81-9.31,12.81s-9.31-7.67-9.31-12.81,4.17-13.58,9.31-13.58S416.15,261.77,416.15,266.91Z"
                          transform="translate(-243.42 -248.22)" id="11"></path>
                    <text y="-2" x="187">21</text>
                    {this.renderComponent("21", 186, 15, "attach")}
                    {this.renderComponent("21", 185, -22, "elastico")}
                    {this.renderComponent("21", 185, 35, "potenciador")}
                    {this.renderComponent("21", 185, -40, "boton")}


                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M443.85,266.91c0,5.14-4.17,12.81-9.31,12.81s-9.31-7.67-9.31-12.81,4.17-13.58,9.31-13.58S443.85,261.77,443.85,266.91Z"
                          transform="translate(-243.42 -248.22)" id="21"></path>
                    <text y="0" x="212">22</text>
                    {this.renderComponent("22", 210, 15, "attach")}
                    {this.renderComponent("22", 208, -22, "elastico")}
                    {this.renderComponent("22", 208, 35, "potenciador")}
                    {this.renderComponent("22", 208, -40, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M466.57,266.91c0,4-3.28,10.76-7.32,10.76s-7.32-6.72-7.32-10.76,3.28-11.32,7.32-11.32S466.57,262.87,466.57,266.91Z"
                          transform="translate(-243.42 -248.22)" id="22"></path>
                    <text y="2" x="236">23</text>
                    {_.includes(this.state.selected, "23") &&
                    <g transform="translate(233,15)">
                        <rect y="4.79" width="10.78" height="1.81" fill="#bad636"></rect>
                        <polygon points="5.39 0 10.78 3.9 0 3.9 5.39 0" fill="#bad636"></polygon>
                    </g>
                    }
                    {this.renderComponent("23", 233, 15, "attach")}
                    {this.renderComponent("23", 231, -23, "elastico")}
                    {this.renderComponent("23", 231, 35, "potenciador")}
                    {this.renderComponent("23", 231, -40, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M489.3,266.91c0,4-4.28,11.32-8.32,11.32s-6.32-7.28-6.32-11.32,3.28-11.32,7.32-11.32S489.3,262.87,489.3,266.91Z"
                          transform="translate(-243.42 -248.22)" id="23"></path>
                    <text y="2" x="257">24</text>
                    {_.includes(this.state.selected, "24") &&
                    <g transform="translate(257,15)">
                        <rect y="4.79" width="10.78" height="1.81" fill="#bad636"></rect>
                        <polygon points="5.39 0 10.78 3.9 0 3.9 5.39 0" fill="#bad636"></polygon>
                    </g>
                    }
                    {this.renderComponent("24", 256, 15, "attach")}
                    {this.renderComponent("24", 254, -17, "elastico")}
                    {this.renderComponent("24", 254, 35, "potenciador")}
                    {this.renderComponent("24", 254, -35, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M497.88,268c0-4,3.26-10.29,7.29-10.29s7.29,6.26,7.29,10.29-3.26,10.29-7.29,10.29S497.88,272.07,497.88,268Z"
                          transform="translate(-243.42 -248.22)" id="24"></path>
                    <text y="2" x="280">25</text>
                    {this.renderComponent("25", 278, 15, "attach")}
                    {this.renderComponent("25", 276, -17, "elastico")}
                    {this.renderComponent("25", 276, 35, "potenciador")}
                    {this.renderComponent("25", 276, -35, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M535.25,266.91c0,4-3.28,11.32-7.32,11.32s-7.32-7.28-7.32-11.32,3.28-8.32,7.32-8.32S535.25,262.87,535.25,266.91Z"
                          transform="translate(-243.42 -248.22)" id="25"></path>
                    <text y="5" x="305">26</text>
                    {this.renderComponent("26", 305, 15, "attach")}
                    {this.renderComponent("26", 303, -17, "elastico")}
                    {this.renderComponent("26", 303, 35, "potenciador")}
                    {this.renderComponent("26", 303, -35, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M566.25,266.91c0,4.65-7.77,8.42-12.42,8.42s-12.42-3.77-12.42-8.42,7.77-8.42,12.42-8.42S566.25,262.26,566.25,266.91Z"
                          transform="translate(-243.42 -248.22)" id="26"></path>
                    <text y="5" x="335">27</text>
                    {this.renderComponent("27", 335, 15, "attach")}
                    {this.renderComponent("27", 333, -17, "elastico")}
                    {this.renderComponent("27", 333, 35, "potenciador")}
                    {this.renderComponent("27", 333, -35, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M595.16,266.91c0,4-6.28,7.32-10.32,7.32s-10.32-3.28-10.32-7.32,6.28-7.32,10.32-7.32S595.16,262.87,595.16,266.91Z"
                          transform="translate(-243.42 -248.22)" id="27"></path>
                    <text y="5" x="365">28</text>
                    {this.renderComponent("28", 365, 15, "attach")}
                    {this.renderComponent("28", 362, -17, "elastico")}
                    {this.renderComponent("28", 362, 35, "potenciador")}
                    {this.renderComponent("28", 362, -35, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M595.16,266.91c0,4-6.28,7.32-10.32,7.32s-10.32-3.28-10.32-7.32,6.28-7.32,10.32-7.32S595.16,262.87,595.16,266.91Z"
                          transform="translate(-214 -248.22)" id="28"></path>
                    <text y="83" x="18">47</text>
                    {this.renderComponent("47", 19, 58, "attach")}
                    {this.renderComponent("47", 17, 84, "elastico")}
                    {this.renderComponent("47", 17, 44, "potenciador")}
                    {this.renderComponent("47", 17, 99, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M279.9,310.89c0,4-8.28,7.32-12.32,7.32s-12.32-3.28-12.32-7.32,8.28-7.32,12.32-7.32S279.9,306.85,279.9,310.89Z"
                          transform="translate(-243.42 -248.22)" id="47"></path>
                    <text y="83" x="-17">48</text>
                    {this.renderComponent("48", -14, 58, "attach")}
                    {this.renderComponent("48", -16, 84, "elastico")}
                    {this.renderComponent("48", -16, 44, "potenciador")}
                    {this.renderComponent("48", -16, 99, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M279.9,310.89c0,4-8.28,7.32-12.32,7.32s-12.32-3.28-12.32-7.32,8.28-7.32,12.32-7.32S279.9,306.85,279.9,310.89Z"
                          transform="translate(-276 -248.22)" id="48"></path>
                    <text y="85" x="52">46</text>
                    {this.renderComponent("46", 53, 58, "attach")}
                    {this.renderComponent("46", 51, 84, "elastico")}
                    {this.renderComponent("46", 51, 44, "potenciador")}
                    {this.renderComponent("46", 51, 99, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M316.41,312.11c0,4.72-8.82,8.54-13.54,8.54s-12.54-3.82-12.54-8.54,7.82-8.54,12.54-8.54S316.41,307.39,316.41,312.11Z"
                          transform="translate(-243.42 -248.22)" id="46"></path>
                    <text y="85" x="81">45</text>
                    {this.renderComponent("45", 81, 58, "attach")}
                    {this.renderComponent("45", 79, 84, "elastico")}
                    {this.renderComponent("45", 79, 44, "potenciador")}
                    {this.renderComponent("45", 79, 99, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M324.09,310.89c0-4,3.26-10.29,7.29-10.29s7.29,6.26,7.29,10.29-3.26,9.29-7.29,9.29S324.09,314.92,324.09,310.89Z"
                          transform="translate(-243.42 -248.22)" id="45"></path>
                    <text y="85" x="103">44</text>
                    {this.renderComponent("44", 105, 58, "attach")}
                    {this.renderComponent("44", 103, 84, "elastico")}
                    {this.renderComponent("44", 103, 44, "potenciador")}
                    {this.renderComponent("44", 103, 99, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M346.37,310.89c0-4,3.26-10.29,7.29-10.29s7.29,6.26,7.29,10.29-3.26,10.29-7.29,10.29S346.37,314.92,346.37,310.89Z"
                          transform="translate(-243.42 -248.22)" id="44"></path>
                    <text y="92" x="125">43</text>
                    {this.renderComponent("43", 126, 58, "attach")}
                    {this.renderComponent("43", 124, 94, "elastico")}
                    {this.renderComponent("43", 124, 44, "potenciador")}
                    {this.renderComponent("43", 124, 109, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M368,311.72c0-4.48,3.63-10.11,8.11-10.11s8.11,5.63,8.11,10.11-3.63,14.11-8.11,14.11S368,316.2,368,311.72Z"
                          transform="translate(-243.42 -248.22)" id="43"></path>
                    <text y="92" x="147">42</text>
                    {this.renderComponent("42", 148, 58, "attach")}
                    {this.renderComponent("42", 146, 94, "elastico")}
                    {this.renderComponent("42", 146, 44, "potenciador")}
                    {this.renderComponent("42", 146, 109, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M396,324.59c-3.8,0-6.87-9.08-6.87-12.87s3.08-8.87,6.87-8.87,6.87,5.08,6.87,8.87S399.82,324.59,396,324.59Z"
                          transform="translate(-243.42 -248.22)" id="42"></path>
                    <text y="92" x="163">41</text>
                    {this.renderComponent("41", 163, 58, "attach")}
                    {this.renderComponent("41", 161, 94, "elastico")}
                    {this.renderComponent("41", 161, 44, "potenciador")}
                    {this.renderComponent("41", 161, 109, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M411.9,325.59c-3.8,0-6.87-12.08-6.87-15.87a6.87,6.87,0,0,1,13.75,0C418.77,313.51,415.7,325.59,411.9,325.59Z"
                          transform="translate(-243.42 -248.22)" id="41"></path>
                    <text y="91" x="181">31</text>
                    {this.renderComponent("31", 180, 58, "attach")}
                    {this.renderComponent("31", 182, 94, "elastico")}
                    {this.renderComponent("31", 182, 44, "potenciador")}
                    {this.renderComponent("31", 182, 109, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M429.54,325.59c-3.8,0-6.87-12.08-6.87-15.87a6.87,6.87,0,0,1,13.75,0C436.41,313.51,433.33,325.59,429.54,325.59Z"
                          transform="translate(-243.42 -248.22)" id="31"></path>
                    <text y="92" x="198">32</text>
                    {this.renderComponent("32", 196, 58, "attach")}
                    {this.renderComponent("32", 198, 94, "elastico")}
                    {this.renderComponent("32", 198, 44, "potenciador")}
                    {this.renderComponent("32", 198, 109, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M445.05,325.59c-3.8,0-6.87-10.08-6.87-13.87s3.08-8.87,6.87-8.87,6.87,5.08,6.87,8.87S448.85,325.59,445.05,325.59Z"
                          transform="translate(-243.42 -248.22)" id="32"></path>
                    <text y="92" x="220">33</text>
                    {this.renderComponent("33", 218, 58, "attach")}
                    {this.renderComponent("33", 216, 94, "elastico")}
                    {this.renderComponent("33", 216, 44, "potenciador")}
                    {this.renderComponent("33", 216, 109, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M457.6,311.72c0-4.48,3.63-9.11,8.11-9.11s8.11,4.63,8.11,9.11-3.63,15.11-8.11,15.11S457.6,316.2,457.6,311.72Z"
                          transform="translate(-243.42 -248.22)" id="33"></path>
                    <text y="85" x="239">34</text>
                    {this.renderComponent("34", 239, 58, "attach")}
                    {this.renderComponent("34", 237, 84, "elastico")}
                    {this.renderComponent("34", 237, 44, "potenciador")}
                    {this.renderComponent("34", 237, 99, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M480.66,310.89c0-4,3.26-9.29,7.29-9.29s7.29,5.26,7.29,9.29-3.26,10.29-7.29,10.29S480.66,314.92,480.66,310.89Z"
                          transform="translate(-243.42 -248.22)" id="34"></path>
                    <text y="85" x="262">35</text>
                    {this.renderComponent("35", 262, 58, "attach")}
                    {this.renderComponent("35", 260, 84, "elastico")}
                    {this.renderComponent("35", 260, 44, "potenciador")}
                    {this.renderComponent("35", 260, 99, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M503.83,310.89c0-4,3.26-9.29,7.29-9.29s7.29,5.26,7.29,9.29-3.26,9.29-7.29,9.29S503.83,314.92,503.83,310.89Z"
                          transform="translate(-243.42 -248.22)" id="35"></path>
                    <text y="85" x="290">36</text>
                    {this.renderComponent("36", 290, 58, "attach")}
                    {this.renderComponent("36", 288, 84, "elastico")}
                    {this.renderComponent("36", 288, 44, "potenciador")}
                    {this.renderComponent("36", 288, 99, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M552.91,312.11c0,4.72-7.82,8.54-12.54,8.54s-13.54-3.82-13.54-8.54,8.82-8.54,13.54-8.54S552.91,307.39,552.91,312.11Z"
                          transform="translate(-243.42 -248.22)" id="36"></path>
                    <text y="82" x="325">37</text>
                    {this.renderComponent("37", 325, 58, "attach")}
                    {this.renderComponent("37", 323, 84, "elastico")}
                    {this.renderComponent("37", 323, 44, "potenciador")}
                    {this.renderComponent("37", 323, 99, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M587.78,310.89c0,4-8.28,7.32-12.32,7.32s-14.32-3.28-14.32-7.32,10.28-7.32,14.32-7.32S587.78,306.85,587.78,310.89Z"
                          transform="translate(-243.42 -248.22)" id="37"></path>
                    {this.renderComponent("38", 360, 58, "attach")}
                    {this.renderComponent("38", 358, 84, "elastico")}
                    {this.renderComponent("38", 358, 44, "potenciador")}
                    {this.renderComponent("38", 358, 99, "boton")}

                    <path className="od-pieza"
                          onClick={this.clickPiece.bind(this)}
                          d="M587.78,310.89c0,4-8.28,7.32-12.32,7.32s-14.32-3.28-14.32-7.32,10.28-7.32,14.32-7.32S587.78,306.85,587.78,310.89Z"
                          transform="translate(-206 -248.22)" id="38"></path>
                    <text y="82" x="360">38</text>
                </svg>
            </div>
        )
    }
}

export default Odontograma


// WEBPACK FOOTER //
// ./resources/assets/js/components/common/Odontograma.jsx